import React, { Component } from 'react';

import { HiOutlineArrowRight } from 'react-icons/hi';

export class ItemContent extends Component {
   render() {
      return (
         <div className="job_material--box">
            <span className='material__title'>{this.props.item.title}</span>
            <span className='material__text'>{this.props.item.about}</span>
            <button className='material_btn' onClick={() => this.props.onShowItem(this.props.item)}>View more<HiOutlineArrowRight /></button>
         </div >
      )
   }
}

export default ItemContent;